import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { ExportIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ExportPopup from 'components/export/confirmation';
import { confirmationOpenSelector, closeConfirmation, createDelayedExport } from './slice';
const noWrapCss = "nldjiam";
const NoWrap = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(noWrapCss, props.className)} />;
});
export const ExportButton = props => {
  const dispatch = useDispatch();
  const confirmationOpen = useSelector(confirmationOpenSelector);
  return <>
      <Button size="small" decoration="secondary-outline" onClick={() => dispatch(createDelayedExport())} {...props}>
        <ExportIcon />
        <NoWrap>{I18n.t('publisher.action.export')}</NoWrap>
      </Button>
      {confirmationOpen && <ExportPopup onConfirm={() => dispatch(closeConfirmation())} />}
    </>;
};

require("./button.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./button.js");